import { nationalLicenseRoute } from "./national-license-routes";

export default (router: any) => {
  nationalLicenseRoute.forEach((route: any) => {
    router.addRoute(route);
  });
};
